import { render, staticRenderFns } from "./keywords.vue?vue&type=template&id=360737b6&scoped=true"
import script from "./keywords.vue?vue&type=script&lang=js"
export * from "./keywords.vue?vue&type=script&lang=js"
import style0 from "./keywords.vue?vue&type=style&index=0&id=360737b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360737b6",
  null
  
)

export default component.exports